import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setModal, selectModal } from "../../../redux/modalSlice";

export default function PayOffModal() {
  const dispatch = useDispatch();
  const modal = useSelector(selectModal);

  const [amount, setPayOffDate] = useState('');

  const handleCancel = () => {
    dispatch(setModal({ is_active: false }));
  };

  const handleSchedulePayoff = () => {
    // Implement the logic for scheduling payoff
    // ...
  };

  return modal.is_active && modal.type === 'pay_off' ? (
    <div className="modal is-active">
      <div className="modal-background"></div>
      <div className="modal-card column is-3">
        <header className="modal-card-head py-3">
          <p className="modal-card-title is-capitalized">
            Pay Off
          </p>
          <button className="delete" aria-label="close" onClick={handleCancel}></button>
        </header>
        <section
          className="modal-card-body modal-card-body pt-1 pb-1"
          style={{ height: "210px", overflow: 'hidden' }}
        >
          <div className="columns mb-0 is-flex-direction-column">
            <div className="column">
              <h3>Select a date for payoff</h3>
            </div>
          </div>
          <div className="field is-horizontal">
            <div className="field-label has-text-left">
              <label className="label has-text-weight-normal">Scheduled Date:</label>
            </div>
            <div className="field-body is-flex-grow-1">
              <div className="field">
                <div className="control">
                  <input
                    type="date"
                    className="input"
                    value={amount}
                    onChange={(e) => setPayOffDate(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="field is-horizontal">
            <div className="field-label has-text-left">
              <label className="label has-text-weight-normal">Pay Off amount:</label>
            </div>
            <div className="field-body is-flex-grow-1">
              <div className="field">
                <div className="control">
                  <input
                    type="number"
                    className="input"
                    value={amount}
                    onChange={(e) => setPayOffDate(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="columns mb-0 is-flex-direction-column">
            <div className="column">
              <h3>PayOff amount is correct assuming all pending payments clear successfully. Otherwise there will be an outstanding balance still owed.</h3>
            </div>
          </div>
        </section>
        <footer className="modal-card-foot is-justify-content-end py-1">
          <div className="lox-form__buttons-wrapper has-text-right">
            <button type="button" className="button is-small has-background-grey has-text-white" onClick={handleCancel}>Cancel</button>
            <button type="submit" className="button is-link is-small" onClick={handleSchedulePayoff}> Schedule Payoff</button>
          </div>
        </footer>
      </div>
    </div>
  ) : null;
}
